// extracted by mini-css-extract-plugin
module.exports = {"card":"f_c","flex":"f_n"};